import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {
  FlexItem,
  FlexLayout,
  StackLayout, Text, Card, Spinner
} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import '../CommonCard.css';
import Constants from '../../components/common/Constants';

import CardAlert from "../../components/common/card-alert/CardAlert";
import PageNavigation from '../../components/common/page-navigation/PageNavigation';
import {useLocation, useNavigate} from 'react-router';
import PasswordExpiringSoonModal from '../../components/common/PasswordExpiringSoonModal';
import {success} from '../../api/LoginApi';
import {useIntl} from 'react-intl';

function ForgotPasswordSuccess(props) {

  const location = useLocation();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(true);
  const [passwordExpiryFormData, setPasswordExpiryFormData] = useState({daysUntilNextReminder: 90});
  const {daysUntilPasswordExpires, passwordExpiryDate} = location.state || {};
  const [errorMessage, setErrorMessage] = useState("");
  const[isLoading,setIsLoading]=useState(false);
  const[showRedirect,setShowRedirect]=useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const intl = useIntl();
  const mainRef = useRef(null);
  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.forgotpassword.step3.page.title'});
    setErrorMessage(
      (passwordExpiryDate === null || passwordExpiryDate === "" || daysUntilPasswordExpires === 0)
        ? Constants.passwordChangeSuccessMessage
        : Constants.forgotPasswordPasswordChangeSuccessMessageWithDate(daysUntilPasswordExpires, passwordExpiryDate)
    );
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    const expectedPreviousPage = '/forgotPasswordComplete';
    if (location.state?.from !== expectedPreviousPage) {
      navigate('/');
    }
  }, [passwordExpiryDate, navigate, location]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setIsSubmitting(true);

    const passwordExpiryData = await success(sessionStorage.getItem("orgName"), sessionStorage.getItem("loginName")
    );
    if (passwordExpiryData.data.reminderRequired) {
      setIsLoading(false);
      setPasswordExpiryFormData({...passwordExpiryData.data});
      props.fillAndOpenModel(<PasswordExpiringSoonModal closeAndClearModal={props.closeAndClearModal}
        fillAndOpenModel={props.fillAndOpenModel} passwordExpiryFormData={passwordExpiryData.data} setShowRedirect={setShowRedirect} useTargetRedirect={false}/>)
    } else {
      window.location.href = `${window.location.origin}/card/home`;
    }

    if(showRedirect)
    {
      window.location.href = `${window.location.origin}/card/home`;
    }
  };

  // Disable browser back button
  useEffect(() => {
    // Push current state to history to ensure there's something to replace
    window.history.pushState(null, null, window.location.href);

    // Handle back button press
    const handleBackButton = (e) => {
      // Push another state to prevent going back
      window.history.pushState(null, null, window.location.href);

      // Optional: Show a message to the user
      setHasError(true);
      setErrorMessage("For security reasons, please use the provided navigation buttons.");
    };

    // Add event listener for back button
    window.addEventListener('popstate', handleBackButton);

    // Cleanup function
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <main ref={mainRef} role="main" aria-label="Forgot Password Success" tabIndex="-1">
    <FlexLayout className={"page-content"}>
      <FlexItem className={`error-wrapper ${hasError || isLoading ? 'visible' : ''}`}>
        <div>
          {isLoading || showRedirect ? (
              <FlexItem className="spinner-wrapper">
                <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
              </FlexItem>
          ) : (
              <CardAlert status={"success"} setHasError={setHasError}>
                {errorMessage}
              </CardAlert>
          )}
        </div>
      </FlexItem>
      <FlexItem>
        <Card className={"card-wrapper"}>
          <FlexItem className="card-content">
            <fieldset disabled={isSubmitting} style={{border:0, padding:0, margin:0}}>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <StackLayout gap={3}>

                <CardHeader style={{maxWidth: '15.5rem'}} heading={Constants.forgotPasswordTitle}
                  subheading={Constants.forgotPasswordStep3Title} />

                <StepTracker label1={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step1'})} step1="completed"
                  label2={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step2'})} step2="completed"
                  label3={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step3'})} step3="completed" />
                <FlexItem>
                  <Text>
                    {Constants.forgotPasswordStep3SuccessInstructionHeader1}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <Text>
                    {Constants.forgotPasswordStep3SuccessInstructionHeader2}
                  </Text>
                </FlexItem>
              </StackLayout>
              <PageNavigation style={{marginTop: "50%"}} isContinue={true} buttonText="CONTINUE" />
            </form>
            </fieldset>
          </FlexItem>
        </Card>
      </FlexItem>
    </FlexLayout>
    </main>
  );

}

export default ForgotPasswordSuccess;